


































import { Component, Vue } from 'vue-property-decorator';

// @ts-ignore
import { Header } from '@coreui/vue';

import { loginService } from '@/services';

import AppHeaderDropdown from '@/components/header/AppHeaderDropdown.vue';

import {
  UserDetail,
  RoleEnum,
} from '@/models';

@Component({
  components: {
    Header,
    AppHeaderDropdown,
  },
})
export default class ClientLayout extends Vue {

  public currentUser: UserDetail = new UserDetail();
  public currentRole: string = '';

  private created() {
    // Get from store
    this.currentUser = this.$store.state.user;
    this.loadUserInfo();
  }

  private beforeUpdate() {
    // Get from store
    this.currentUser = this.$store.state.user;
    this.loadUserInfo();
  }

  private loadUserInfo() {
    // Check user roles
    let isAdmin: boolean = false;
    let isUser: boolean = false;
    let isWarehouse: boolean = false;
    let isAgency: boolean = false;
    let isCompany: boolean = false;
    let isBtjCompany: boolean = false;
    if (!this.currentUser.role) {
      return;
    }
    if (this.currentUser.role === RoleEnum.ROLE_ADMIN || this.currentUser.role === RoleEnum.ROLE_COMPANY_ADMIN) {
      isAdmin = true;
    } else if (this.currentUser.role === RoleEnum.ROLE_USER) {
      isUser = true;
    } else if (this.currentUser.role === RoleEnum.ROLE_WAREHOUSE) {
      isWarehouse = true;
    } else if (this.currentUser.role === RoleEnum.ROLE_AGENCY) {
      isAgency = true;
    } else if (this.currentUser.role === RoleEnum.ROLE_COMPANY) {
      isCompany = true;
    } else if (this.currentUser.role === RoleEnum.ROLE_BTJ_COMPANY) {
      isBtjCompany = true;
    }
    // Load nav item based on user roles
    if (isAdmin) {
      this.currentRole = 'roles.admin';
    } else if (isUser) {
      this.currentRole = 'roles.user';
    } else if (isAgency) {
      this.currentRole = 'roles.agency';
    } else if (isWarehouse) {
      this.currentRole = 'roles.warehouse';
    } else if (isCompany) {
      this.currentRole = 'roles.company';
    } else if (isBtjCompany) {
      this.currentRole = 'roles.btj';
    }
  }

  private getBadgeClass(): string {
    if (this.currentRole === 'roles.admin' || this.currentRole === 'roles.user') {
      return 'color-admin';
    } else if (this.currentRole === 'roles.warehouse') {
      return 'color-warehouse';
    } else if (this.currentRole === 'roles.agency') {
      return 'color-agency';
    } else if (this.currentRole === 'roles.company') {
      return 'color-company';
    } else if (this.currentRole === 'roles.btj') {
      return 'color-btj';
    } else {
      return '';
    }
  }

  private isBTJRole() {
    if (this.currentUser && this.currentUser.role === RoleEnum.ROLE_BTJ_COMPANY) {
      return true;
    }
    return false;
  }

  private goToCMS() {
    window.location.href = process.env.VUE_APP_ROOT_API + '/admin/notify';
  }
}
